import React, { useState, useRef } from "react";
import { useSelector, } from "react-redux";
import { useLoading } from "../../../hooks/useLoading";
import { ListItemIcon, Menu, MenuItem, } from "@mui/material";
import MaterailTable from "../Elements/MaterialTable";
import ReSendLinkModal from "./ReSendLinkModal";
import { formatCurrency, formatDateOnFront } from "../../../lib/helpers";
import { linkSendStatus } from "../../../common/helpers/linkStatusFiledis";
import StatusBox from "../Elements/StatusBox";
import { sendTypeIds } from "../../../constants/options/sendOptions";
import { FaEllipsisV } from "react-icons/fa";
import { Send } from "@mui/icons-material";
import { muiMenuStyles } from "../../../constants/muiMenuStyles";
import { getSendTypeDescHelper } from "../../../common/helpers/getSendTypeDescHelper";
import { render } from "@testing-library/react";

export default function LinksTable() {
  const classes = muiMenuStyles();

  const resendLinkModalRef = useRef();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const isopenMenu = Boolean(anchorEl);
  const [dropdownAllValues, setDropdownAllValues] = useState({});

  const {
    links,
    isFetching,
    isError,
    isfetchComplete
  } = useSelector((state) => state.linklist);

  const loading = useLoading(isFetching);

  const openSendAgainModal = (id) => {

    handleClose();
    const index = links.findIndex(w => w.id == id);
    const row = links[index];
    var params = {
      amount: row.amount,
      sendtype: row.sendTypeId || 3,
      phone: row.phone,
      email: row.email,
      lastlinkdate: "",
      customerName: row.customername,
      customerCode: row.customercode,
      paymentLinkId: id
    }
    resendLinkModalRef.current.openModal(params);
  };


  const handleClickMenu = (event, row) => {
    setDropdownAllValues(row);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const getSmsMailStatus = (status) => {
    const boxWidth = "w-[115px]";

    switch (status) {
      case linkSendStatus.forward:
        return (
          <StatusBox content="Link İletildi" statusType="primary" className={boxWidth} />
        );
      case linkSendStatus.notForward:
        return (
          <StatusBox content="Link İletilemedi" statusType="error" className={boxWidth} />
        );
      case linkSendStatus.linkOpen:
        return (
          <StatusBox content="Link Açıldı" statusType="success" className={boxWidth} />
        );
      case linkSendStatus.readLink:
        return (
          <StatusBox content="Okundu" statusType="primary" className={boxWidth} />
        );
      case linkSendStatus.waitSend:
        return (
          <StatusBox content="Gönderim Bekleniyor" statusType="warning" className={boxWidth} />
        );
      default:
        return null;
    }
  }

  function getRowStatusBySendType(row) {
    const { mailStatus, smsStatus, sendTypeId, whatsappStatus } = row;
    var status = mailStatus;
    switch (sendTypeId) {
      case sendTypeIds.emailAndSms:
        status = mailStatus || smsStatus || whatsappStatus;
        break;
      case sendTypeIds.sms:
        status = smsStatus;
        break;
      case sendTypeIds.whatsapp:
        status = whatsappStatus || linkSendStatus.waitSend;
        break;
      default:
        break;
    }
    return status;
  }

  const DropdownMenu = ({ row }) => {
    return (
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={isopenMenu}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        classes={{
          paper: classes.paper,
        }}
      >
        <MenuItem onClick={() => {
          openSendAgainModal(dropdownAllValues.id);
        }}>
          <ListItemIcon>
            <Send fontSize="small" />
          </ListItemIcon>
          Düzenle Ve Yeniden Gönder
        </MenuItem>
      </Menu>
    );
  }

  const getPaymentStatus = (row) => {
    const { mailStatus, smsStatus, status, sendTypeId } = row;
    const rowStatus = getRowStatusBySendType(row);

    const getStatusBox = (content, statusType) => (
      <StatusBox content={content} statusType={statusType} />
    );

    if (status === "success") {
      return getStatusBox("Başarılı", "success");
    }

    if (sendTypeId === sendTypeIds.link || sendTypeId === sendTypeIds.qr) {
      return getStatusBox("Link Oluşturuldu", "primary");
    }

    if (status === "error" || rowStatus === linkSendStatus.notForward) {
      return getStatusBox("Başarısız", "error");
    }

    return getStatusBox("Ödeme Bekliyor", "warning");
  }

  const headCells = [
    {
      id: 'operations',
      numeric: false,
      label: 'İşlemler',
      exceptToExcel: true,
      disablePadding: true,
      isRender: true,
      disableSortIcon: true,
      renderRow: (row) => {
        return (
          <div className="flex flex-row justify-around items-center">

            <a id="basic-button"
              aria-controls={isopenMenu ? 'basic-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={isopenMenu ? 'true' : undefined}
              className="cursor-pointer"
              onClick={(event) => handleClickMenu(event, row)}>
              <FaEllipsisV
                className="block sm:block ml-1 h-3 w-3 font-light"
              />
            </a>
            <DropdownMenu row={row}>

            </DropdownMenu>

          </div>
        );
      }
    },
    {
      id: 'id',
      numeric: false,
      disablePadding: true,
      label: 'id',
      isprimary: true,
      className: "min-w-[90px]",
      hide: true
    },
    {
      id: 'createDate',
      numeric: false,
      disablePadding: false,
      label: 'Oluşturma Tarihi ',
      className: "min-w-[180px]",
      isRender: true,
      renderRow: (row) => {

        return (
          <div className="text-left">
            {formatDateOnFront(row.createdate)}
          </div>
        );
      }
    },
    {
      id: 'customercode',
      numeric: true,
      disablePadding: false,
      label: 'Cari Hesap Kodu',
      className: "min-w-[155px]",
      maxLength: 20
    },
    {
      id: 'customername',
      numeric: false,
      disablePadding: true,
      label: 'Cari Hesap Ünvan',
      className: "min-w-[360px]",
      maxLength: 50,
    },
    {
      id: 'taxNo',
      numeric: true,
      disablePadding: false,
      label: 'VKN/TCKN',
      className: "min-w-[180px]",
      maxLength: 11
    },
    {
      id: 'email',
      numeric: true,
      disablePadding: false,
      label: 'E-Posta Adresi ',
      className: "max-w-[220px]",
      maxLength: 30
    },
    {
      id: 'phone',
      numeric: true,
      disablePadding: false,
      label: 'Telefon ',
      className: "max-w-[220px]",
      maxLength: 30
    },
    {
      id: 'invoiceNumber', 
      numeric: false,
      disablePadding: false,
      label: 'Fatura Numarası ',
      className: "min-w-[180px]",
      isMoney: false,
      maxLength: 15,
    },
    {
      id: 'gibInvoiceNumber', 
      numeric: false,
      disablePadding: false,
      label: 'Gib Fat. Numarası ',
      className: "min-w-[180px]",
      isMoney: false,
      maxLength: 15,
    },
    {
      id: 'linkDesc',
      numeric: false,
      disablePadding: true,
      label: 'Link Açıklaması',
      className: "min-w-[250px]",
      maxLength: 50,
    },
    {
      id: 'vpDisplayName',
      numeric: false,
      disablePadding: true,
      label: 'Ödeme Altyapısı',
      className: "min-w-[155px]",
      maxLength: 15,
      colWidth: 20,
    },
    {
      id: 'amount',
      numeric: true,
      disablePadding: false,
      label: 'Tutar ',
      className: "min-w-[140px]",
      isMoney: true,
      maxLength: 15,
      isRender: true,
      renderRow: (row) => {
        return (
          <div>
            {formatCurrency(parseFloat(row.amount)) + row.currencySymbol}
          </div>
        );
      }
    },
    {
      id: 'linkstatus',
      numeric: true,
      disablePadding: false,
      label: 'Link Durumu',
      className: "min-w-[160px]",
      isRender: true,
      forcealign: "center",
      renderRow: (row) => {
        var status = getRowStatusBySendType(row);
        return getSmsMailStatus(status);
      }
    },
    {
      id: 'status',
      numeric: true,
      disablePadding: false,
      label: 'Ödeme Durumu',
      className: "min-w-[160px]",
      isRender: true,
      forcealign: "center",
      renderRow: (row) => {
        return getPaymentStatus(row);
      }
    },
    {
      id: 'sendTypeId',
      numeric: true,
      disablePadding: false,
      label: 'Gönderim Türü',
      className: "min-w-[150px]",
      isRender: true,
      renderRow: (row) => {
        return (
          <div>
            {getSendTypeDescHelper(row.sendTypeId)}
          </div>
        );
      }
    },
  ];

  return (
    <>
      <ReSendLinkModal ref={resendLinkModalRef}></ReSendLinkModal>
      <MaterailTable headerCells={headCells} tableData={links} isLoading={loading} isError={isError} emptyMessage={isfetchComplete ? "Verilen kritere uygun kayıt bulunamamıştır" : ""} ></MaterailTable>
    </>
  );









}
